import '@google/model-viewer';
import React, { Component } from 'react';
import 'react-image-lightbox/style.css'; // This only needs to be imported once in your app
import "./meta.style.css";
import "./style.css";

export default class Info3DView extends Component {

    render() {
        return <div className="info-panel-3d">
            <model-viewer
                src={this.props.filePath}
                ar ar-modes="webxr scene-viewer quick-look"
                environment-image="neutral"
                auto-rotate camera-controls></model-viewer>
        </div>
    }
}
